
<div class="img-check-box" @click="toggle">
  <img :src="img" />
  <div v-if="sChecked" class="check-item">
    <a-icon type="check" />
  </div>
</div>
